import React, { useContext, useEffect } from 'react';
import TableauReport from '@/pages/home/components/Tableau';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';
import { LayoutContext } from '@/pages/benchmark/state/LayoutContext';
import { getLogTypeId } from '@/pages/benchmark/utils/utils';

const Tableau = () => {
  const { frameType, currentMenu } = useContext(LayoutContext);
  const {
    url
  } = currentMenu || {};

  useEffect(() => {
    if (!currentMenu) {
      return;
    }
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '800801',
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: `/tableau/report/${nameEn || ''}`,
      uidType: '', // 基准打点不包含uidType
      typeId: getLogTypeId(frameType),
    };
    buriedPoint(logObj);
  }, [currentMenu, frameType]);

  return (<>{url && <TableauReport url={url} style={{ padding: '0px' }} />}</>);
};

export default Tableau;